import * as types from './_actionTypes';

export const fetchSmeDashboardRequest = () => ({
  type: types.FETCH_SME_DASHBOARD_REQUEST
});

export const fetchSmeDashboardSuccess = (data) => ({
  type: types.FETCH_SME_DASHBOARD_SUCCESS,
  payload: data
});

export const fetchSmeDashboardFailure = (error) => ({
  type: types.FETCH_SME_DASHBOARD_FAILURE,
  payload: error
});

export const fetchSmeAnalyticsRequest = () => ({
  type: types.FETCH_SME_ANALYTICS_REQUEST
});

export const fetchSmeAnalyticsSuccess = (analytics) => ({
  type: types.FETCH_SME_ANALYTICS_SUCCESS,
  payload: analytics
});

export const fetchSmeAnalyticsFailure = (error) => ({
  type: types.FETCH_SME_ANALYTICS_FAILURE,
  payload: error
});